export const initialState = {
  dadosUsuario: {
    nomeCompleto: '',
    cpf: '',
    dataNascimento: '',
    email: '',
    celular: '',
    checkBoxNotificacao: false,
  },
  tipoVeiculo: '',
  temNFC: true,
  listaDeProdutos: [],
  ondeUsar: {
    id: '',
    texto: '',
    temMensalidade: true,
    valor: '',
    textoDesconto: '',
    placa: '',
  },
  receberAdesivo: '',
  dadosEndereco: {
    cep: '',
    cidade: '',
    estado: '',
    bairro: '',
    endereco: '',
    numero: '',
    complemento: '',
  },
  tipoPagamento: '',
  dadosCartao: {
    numero: '',
    validade: '',
    CVV: '',
    melhorDiaCobranca: '',
    nome: '',
  },
  debitoEmConta: {
    instituicao: '',
    agencia: '',
    conta: '',
    digitoConta: '',
    melhorDiaCobranca: '',
  },
  dadosDePagamentoValido: { status: false, tipo: '' },
  totalProdutos: {
    valorTotalProdutos: 0,
    qtdTotalProdutos: 0,
    nomeQtdProdutos: '',
  },
  dadosVeiculo: {
    placa: "",
    confirmPlaca: "",
    categoriaVeiculo: "CARRO",
    categoriaEixo: ""
  },
  featureFlag: {
    enabled: false,
    data: {},
  },
  cupomDesconto: { codigoCupom: '', valorDesconto: 0 },
  loader_active: false,
  captchaResponse: '',
  valorRecarga: 0,
  codigoPromocional: {
    codigoValido: false,
    codigo: {
      origem: '',
      name: '',
    },
    planosCodigo: [],
    planosDefault: [],
    planos: {
      todos: [],
      opcoes: [],
    },
  },
};
